import React from 'react'
import PropTypes from 'prop-types'
import {Input} from 'antd'

const ReferenceSearch = ({ placeholder, value, onChange, testId }) => (
  <Input
    autoComplete="off"
    type="search"
    className="connector-mapping-ref-search"
    data-testid={testId}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
  />
)

ReferenceSearch.propTypes = {
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  testId: PropTypes.string,
}

export default ReferenceSearch
